import apiFetch from '../apiFetch'

export default function (token, item) {
  return apiFetch({ endPoint: 'DestinationCrane/PutItem', method: 'PUT', body: item, token: token })
}
